import Div from "../../components/atoms/Div";
import ContentDividerSvg from "../svgs/ContentDividerSvg";

export default function ContentDivider({fillColour}) {
	return (
		<Div position="absolute" bottom={'calc(100% - 5px)'} left={'0'} right={'0'} zIndex={'1'}>
			<ContentDividerSvg fillColour={fillColour}/>
		</Div>
	)
}